<script lang="ts" setup>
import RendererLayout from '@/presentation/layouts/RendererLayout.vue';
import ToastContainer from '@/presentation/components/common/toast/ToastContainer.vue';
</script>

<template>
	<RendererLayout>
		<RouterView />
	</RendererLayout>
	<ToastContainer />
</template>
<style lang="scss">
@use './assets/css/main.css';
</style>
